module.exports = __webpack_public_path__ + "static/media/Wal.920c6eec.jpg";